import { email } from '@vuelidate/validators'

const PHONE_REGEX = /^\+?\d{7,15}$/

export const isValidEmail = (value: string): boolean => {
  const trimmed = value.trim()
  return !!trimmed && email.$validator(trimmed, null, null) === true
}

export const isValidPhone = (value: string): boolean => PHONE_REGEX.test(value.trim().replace(/[\s()-]/g, ''))
